import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcListDot(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    fill: "none",
    viewBox: "0 0 14 14",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 1,
    fill: "#6E6F73"
  }));
}
var IcListDot = createNolIcon(/*#__PURE__*/forwardRef(SvgIcListDot));

export { IcListDot as I };
